import Page, {
    getServerSideProps as compGetServerSideProps,
} from 'components/pages/Home';

export const getServerSideProps = compGetServerSideProps;
export default Page;
